export default {"src":"/_next/static/media/dhl.ec3993a6.svg","height":601,"width":2500,"blurWidth":0,"blurHeight":0};